import React from 'react';
import { bool, number, shape, string } from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import TerminalStatusChip from '../TerminalStatusChip';

const Popup = ({
  hasAffiliateWithSubscription,
  terminal: {
    address,
    alertCount,
    city,
    currentBusynessLevel,
    displayDistance,
    state,
    terminalId,
    terminalIdName,
    zipcode,
  },
}) => (
  <Box
    sx={{
      '> *': {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      },
      display: 'flex',
      flexDirection: 'row',
    }}
  >
    <Box>
      <Box>
        <a
          href={`#${terminalId}`}
          style={{ fontSize: 18, fontWeight: 400, textDecoration: 'none' }}
        >
          <Button className="map-popup__terminal-id-name" variant="text">
            <Badge
              invisible={!alertCount}
              sx={{
                '.MuiBadge-badge': {
                  backgroundColor: 'error.dark',
                  right: -10,
                  top: '10%',
                },
              }}
              variant="dot"
            >
              {terminalIdName}
            </Badge>
          </Button>
        </a>
      </Box>
      <Box className="map-popup__address">{address}</Box>
      <Box className="map-popup__address">
        {city}, {state} {zipcode}
      </Box>
      <Box
        className="map-popup__distance"
        sx={{
          mt: 1,
        }}
      >
        {displayDistance ?? '--'}
      </Box>
      {hasAffiliateWithSubscription && (
        <Box>
          <TerminalStatusChip status={currentBusynessLevel ?? 'Unknown'} />
        </Box>
      )}
    </Box>
  </Box>
);

Popup.propTypes = {
  hasAffiliateWithSubscription: bool.isRequired,
  terminal: shape({
    address: string,
    alertCount: number,
    city: string,
    currentBusynessLevel: string,
    displayDistance: string,
    state: string,
    terminalId: number,
    terminalIdName: string,
    zipcode: string,
  }).isRequired,
};

export default Popup;
